module.exports = __webpack_public_path__ + "files/6bc472ed2c1c36d37b4fda83415f6d4b.png";